module.exports = __webpack_public_path__ + "static/media/faisal.7556e3b6.jpg";